// extracted by mini-css-extract-plugin
export default {"emptyCard":"empty-card_emptyCard__3-eOd","fadeSlideUp":"empty-card_fadeSlideUp__Zz7Fh","emptyValue":"empty-card_emptyValue__9sXhI","infoIcon":"empty-card_infoIcon__PbosW"};